      
import React, { Component } from 'react'

class MyOrder extends Component {
	

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
		console.log(this.state)
        
          window.location.replace("/order");
	}

	render() {
		
		return (
            <div>
            
            <form  onSubmit={this.submitHandler} action="" >
              <button class="btn btn-dark button2" id="checkingout">
               My Orders
              </button>
          </form>
        
          </div>
          
		)
	}
}

export default MyOrder

